import EntryButton from '@/User/Components/Buttons/EntryButton';
import React from 'react';

const SmallCta = () => (
    <div className="flex justify-center items-center bg-alice-blue-3 border-y-2 border-primary h-22 px-4 md:px-8 lg:px-0">
        <div className="w-85.5">
            <EntryButton classIconName="size-6"/>
        </div>
    </div>
);

export default SmallCta;
